export type ClassDashboardRouteState = {
  activeTabIndex?: number;
};

export enum IncomeStatementType {
  preschoolFees = 'Preschool fees',
  startupSupport = 'Start-up support',
  donationsOrVouchers = 'Donations or vouchers',
  DBESubsidy = 'DBE subsidy',
  otherIncome = 'Other',
}

export enum ExpenseStatementType {
  rent = 'Rent',
  mySalary = 'My Salary',
  salaryAndWages = 'Salary & wages',
  Food = 'Food',
  learningMaterials = 'Learning materials',
  annualMaintenance = 'Annual Maintenance',
  utilities = 'Utilities',
  otherExpense = 'Other',
}
